/* Reconcile presentation after confirmed Shopify cart mutations. Never submit a cart action. */
(function () {
  'use strict';
  if (window.brCartStateReady) return;
  window.brCartStateReady = true;
  var fetchCart = window.fetch.bind(window), version = 0, timer;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function refresh() {
    var current = ++version;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetchCart(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('Cart read failed'); return r.json(); })
        .then(function (cart) {
          if (current !== version || !Number.isInteger(cart.item_count)) return;
          var count = document.getElementById('cart-count');
          if (count && count.textContent !== String(cart.item_count)) count.textContent = String(cart.item_count);
        }).catch(function () { /* Preserve the last confirmed state on network failure. */ });
    }, 80);
  }
  function mutation(input) {
    try {
      var u = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      return u.origin === location.origin && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(u.pathname);
    } catch (_) { return false; }
  }
  var previousFetch = window.fetch;
  window.fetch = function () {
    var result = previousFetch.apply(this, arguments);
    if (mutation(arguments[0])) result.then(function (r) { if (r.ok) refresh(); }, function () {});
    return result;
  };
  var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.brCartMutation = mutation(url);
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.brCartMutation) this.addEventListener('load', function () {
      if (this.status >= 200 && this.status < 300) refresh();
    }, { once: true });
    return send.apply(this, arguments);
  };
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });

  if (!/^fr(?:-|$)/i.test(document.documentElement.lang)) return;
  var labels = {
    '8.2" x 11.6" (Vertical)': 'A4 (20,8 × 29,5 cm)',
    '11.6" x 16.5" (Vertical)': 'A3 (29,5 × 41,9 cm)',
    '16.5" x 23.3" (Vertical)': 'A2 (41,9 × 59,2 cm)',
    '23.3" x 33.1" (Vertical)': 'A1 (59,2 × 84,1 cm)',
    '11.6" x 8.2" (Horizontal)': 'A4 (29,5 × 20,8 cm)',
    '16.5" x 11.6" (Horizontal)': 'A3 (41,9 × 29,5 cm)',
    '23.3" x 16.5" (Horizontal)': 'A2 (59,2 × 41,9 cm)',
    '33.1" x 23.3" (Horizontal)': 'A1 (84,1 × 59,2 cm)',
    'Matte': 'Mat'
  };
  var selector = '.qsc2-product-item__variant-title', pending = false;
  function translate() {
    pending = false;
    document.querySelectorAll(selector).forEach(function (el) {
      var old = el.textContent, text = old;
      Object.keys(labels).forEach(function (key) { text = text.split(key).join(labels[key]); });
      text = window.brFormatLabel(text);
      if (text !== old) el.textContent = text;
    });
  }
  function relevant(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    return el && (el.matches(selector) || el.closest(selector) || el.querySelector(selector));
  }
  var observer = new MutationObserver(function (changes) {
    if (pending) return;
    if (changes.some(function (m) { return relevant(m.target) || Array.from(m.addedNodes).some(relevant); })) {
      pending = true; requestAnimationFrame(translate);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  translate();
})();
